const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service",
            postponed: "Postponed"
          },
          waiting: {
            title: "Waiting for attention"
          },
          closed: {
            title: "Closed today"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          farewellMessage: "Automatic closing message",
          provider: "Connection method",
          providerHelp:
            "Choose how this line connects to WhatsApp. It cannot be changed after creation.",
          providerLockedHelp:
            "The connection method cannot be changed after the line is created.",
          providerOptions: {
            wwebjs: "Standard (recommended) — whatsapp-web.js",
            whaileys: "Alternate (experimental) — Baileys",
          },
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        nameSources: {
          manual: "Manually edited",
          whatsapp_verified: "Business or verified name",
          whatsapp_profile: "WhatsApp profile",
          whatsapp_address_book: "WhatsApp address book",
          provisional: "Provisional name",
          legacy: "Protected existing name",
        },
        nameSourceHelp: {
          manual: "A manually entered or corrected name. WhatsApp will not replace it.",
          whatsapp_verified: "A business or verified name provided by WhatsApp.",
          whatsapp_profile: "The public name set by the person in their WhatsApp profile.",
          whatsapp_address_book: "A name saved in the WhatsApp connection's address book.",
          provisional: "Provisional name: usually the phone number. It can be replaced when WhatsApp provides a better name.",
          legacy: "A name that existed before its source was tracked. It is kept to prevent accidental changes.",
        },
      },
      contactImport: {
        title: "Import WhatsApp Business contacts",
        description: "Select a connection, review the preview and choose only the contacts you want to import. Manually edited names will never be replaced.",
        connection: "WhatsApp connection",
        loadPreview: "Load preview",
        noConnections: "No active WhatsApp connections are available.",
        search: "Search by name or number",
        statusFilter: "Status in Whaticket",
        sourceFilter: "Name source",
        source: {
          all: "All sources",
          addressBook: "Saved address book",
          named: "All with a name",
          verified: "Business or verified",
          profile: "WhatsApp profile",
          provisional: "Numbers only / no name",
        },
        selectRecommended: "Select recommended",
        recommendedHelp: " Selects new contacts and provisional names that can be improved.",
        bulkPhotoWarning: " Selections over 100 skip individual photo lookup to avoid a long wait; existing photos are preserved.",
        rowsPerPage: "Rows per page",
        duplicatesInSource: "{{count}} consolidated records",
        protectedName: "The existing name will be kept: {{name}}",
        status: {
          all: "All",
          new: "New",
          update: "Update name",
          existing: "Already exists",
          protected: "Protected name",
        },
        statusHelp: {
          all: "Shows every contact regardless of its current status in Whaticket.",
          new: "The number is available in WhatsApp but does not exist as a Whaticket contact yet.",
          update: "The contact exists with a provisional name and WhatsApp found a better name.",
          existing: "The contact already exists in Whaticket and does not need a name change.",
          protected: "The contact has a manual or previous name that Whaticket will preserve without overwriting.",
        },
        sourceHelp: {
          all: "Shows contacts without restricting where the name came from.",
          addressBook: "The strongest available signal that the contact is saved in the address book linked to this connection.",
          named: "Shows every contact with a name, even when that name may not be saved in the address book.",
          verified: "WhatsApp publicly knows the business name; this does not prove the operator saved it.",
          profile: "The person set this name in their WhatsApp profile; it may not be saved in the address book.",
          provisional: "WhatsApp only provided the number. This often means an occasional chat or a contact with no available name.",
        },
        summary: {
          available: "Available",
          new: "New",
          update: "Updatable",
          existing: "Existing",
          protected: "Protected",
          duplicates: "Merged duplicates",
          skipped: "Skipped groups or IDs",
        },
        summaryHelp: {
          available: "Total usable unique phone numbers. It is the sum of New, Updatable, Existing and Protected; it is not an additional group.",
          new: "Phone numbers returned by WhatsApp that do not exist as Whaticket contacts yet.",
          update: "Existing contacts whose provisional name can safely be replaced with a better one.",
          existing: "Contacts that already exist and do not need a name change.",
          protected: "Existing contacts with a manual or previous name that Whaticket will not overwrite.",
          duplicates: "Repeated records for the same phone found in the connection and merged into one row; duplicate contacts will not be created.",
          skipped: "Groups and internal LID identifiers used by WhatsApp that do not contain an importable phone number. A high value can be normal.",
        },
        table: {
          name: "Available name",
          number: "Number",
          status: "Expected result",
        },
        cancel: "Cancel",
        close: "Close",
        importing: "Importing...",
        importSelected: "Import selected ({{count}})",
        completed: "Contact import completed.",
        resultTitle: "Import result",
        result: "Created: {{created}} · Updated: {{updated}} · Protected names: {{protected}} · Unchanged: {{unchanged}} · Errors: {{errors}} · Photos skipped for bulk import: {{photosSkipped}}",
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          countryCode: "Country code",
          number: "Whatsapp number",
          numberHint: "Enter the number without the prefix. It will be stored with the selected country code.",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "New department",
          edit: "Edit department",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departments",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to department",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Select a department",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Waiting",
        assignedHeader: "Working on",
        attentionRequired: "Needs attention",
        noAttentionPending: "No tickets need attention",
        attended: "Attended",
        internalTag: "Internal",
        closedTag: "Closed",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        lastSender: {
          customer: "The customer sent the last message",
          operator: "The operator sent the last message",
          unknown: "The last sender is unknown",
        },
        buttons: {
          accept: "Accept",
          reject: "Reject",
        },
        postpone: {
          button: "Postpone",
          activeUntil: "Postponed until {{date}}",
          fifteenMinutes: "15 minutes",
          thirtyMinutes: "30 minutes",
          oneHour: "1 hour",
          twoHours: "2 hours",
          tomorrow: "Until tomorrow",
          more: "More time…",
          toastMessage: "Postponed {{label}}",
          undo: "Undo",
          undoSuccess: "Postponement undone",
          customTitle: "Postpone for longer",
          amountLabel: "Amount",
          unitLabel: "Unit",
          units: {
            minutes: "Minutes",
            hours: "Hours",
            days: "Days",
          },
          confirm: "Postpone",
          cancel: "Cancel",
          invalidAmount: "Enter a valid amount",
          noResponseNeeded: "Doesn't need a reply",
          noResponseSuccess: "Marked as not needing a reply",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Departments",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          user: {
            profile: "Profile",
            notifications: "Notification sound",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      notificationSound: {
        title: "Notification sound",
        enabled: "Play sound",
        enabledHelp: "This option only controls Whaticket sound in this browser.",
        tone: "Tone",
        tones: {
          soft: "Soft (recommended)",
          discreet: "Discreet",
          classic: "Current",
        },
        volume: "Whaticket volume",
        repeatInterval: "Minimum interval between sounds",
        intervals: {
          everyMessage: "For every message",
        },
        seconds: "seconds",
        repeatHelp: "If several messages arrive together, the alert will sound at most once during this interval.",
        test: "Test sound",
        cancel: "Cancel",
        save: "Save",
      },
      phoneConversation: {
        title: "Open conversation by number",
        help: "Review the number and choose the WhatsApp connection that will handle the conversation.",
        number: "Phone number",
        countryCode: "Country code",
        countryHelp: "Use 57 for Colombia. If the number already includes it, it will not be duplicated.",
        name: "Contact name (optional)",
        connection: "Send from connection",
        noConnections: "There are no active WhatsApp connections.",
        noAutomaticMessage: "The ticket will be opened, but no message will be sent automatically.",
        copy: "Copy",
        copied: "Number copied.",
        copyError: "The number could not be copied.",
        cancel: "Cancel",
        start: "Open conversation",
      },
      queues: {
        title: "Departments",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add department",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this department will still exist, but will not have any department assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Departments",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to a department.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          businessDayStartHour: {
            name: "Business day start time",
          },
          businessWorkingDays: {
            name: "Working days",
            days: {
              0: "Sun",
              1: "Mon",
              2: "Tue",
              3: "Wed",
              4: "Thu",
              5: "Fri",
              6: "Sat",
            },
          },
          oldTicketsReminder: {
            name: "Old ticket reminder",
            enabledLabel: "Enable reminder",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
            thresholdDaysLabel: "Days without activity to consider a ticket old",
            intervalMinutesLabel: "Interval between reminders (minutes)",
          },
          postReplySnooze: {
            name: "Postpone after replying",
            secondsLabel: "Available time (seconds, 0 disables)",
          },
        },
      },
      oldTicketsReminder: {
        title: "Old open tickets",
        message:
          "You have {{count}} open ticket with more than {{days}} days without activity. Remember to review and close it when appropriate.",
        message_plural:
          "You have {{count}} open tickets with more than {{days}} days without activity. Remember to review and close them when appropriate.",
        accept: "OK",
      },
      messagesList: {
        download: "Download",
        downloading: "Downloading…",
        downloadError: "The file could not be downloaded. Please try again.",
        history: {
          previousTicket: "Previous conversation · ticket #{{ticketId}}",
          currentTicket: "Current conversation · ticket #{{ticketId}}",
        },
        delivery: {
          pending: "Sending or waiting for WhatsApp confirmation",
          failed: "Send not confirmed. Check before sending it again",
        },
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            reject: "Reject",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        sendImagesAsHd: "Send images in HD",
        sendImagesAsHdHelp: "Higher quality; sending may take a little longer.",
        mediaCaptionPlaceholder: "Add a caption",
        sendContactCard: "Send contact",
        contactCardTitle: "Send contact card",
        contactCardSearch: "Search by name or number",
        contactCardSend: "Send contact",
        contactCardCancel: "Cancel",
        contactCardSent: "Contact card sent.",
        emojis: "Emojis",
        attachFiles: "Attach files",
        sendLocation: "Send location",
        locationTitle: "Send location",
        locationUseCurrent: "Use my current location",
        locationLocating: "Getting location…",
        locationLatitude: "Latitude",
        locationLongitude: "Longitude",
        locationName: "Place name (optional)",
        locationAddress: "Address (optional)",
        locationHelp: "You can copy the coordinates from Google Maps.",
        locationPreview: "Selected location",
        locationOpenMap: "Review map",
        locationSend: "Send location",
        locationCancel: "Cancel",
        locationSent: "Location sent.",
        locationUnavailable: "This browser cannot provide your location.",
        locationPermissionError: "The location could not be obtained. Check browser permission or enter the coordinates.",
      },
      contactDrawer: {
        header: "Contact details",
        phoneUnavailable: "The customer did not share their phone number",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      ticketMute: {
        title: "Mute conversation",
        description: "Choose how long Whaticket should suppress sounds and desktop alerts for this conversation.",
        eightHours: "8 hours",
        oneWeek: "1 week",
        forever: "Always",
        syncWarning: "Whaticket will try to synchronize this change with WhatsApp Business. If WhatsApp does not accept it, muting will still work in Whaticket only.",
        cancel: "Cancel",
        confirm: "Mute",
        mute: "Mute conversation",
        unmute: "Enable notifications",
        muted: "Muted",
        synced: "Conversation muted in Whaticket and WhatsApp.",
        localOnly: "Conversation muted in Whaticket only; WhatsApp did not confirm the change.",
        unmutedSynced: "Notifications enabled in Whaticket and WhatsApp.",
        unmutedLocalOnly: "Notifications enabled in Whaticket; WhatsApp did not confirm the change.",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        open: "Message options",
        delete: "Delete",
        forward: "Forward",
        reply: "Reply",
        react: "React",
        pin: "Pin message",
        unpin: "Unpin message",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      messageReaction: {
        title: "React to message",
        remove: "Remove my reaction",
        cancel: "Cancel",
      },
      messagePin: {
        title: "Pin message",
        description: "Choose how long the message will remain pinned in this WhatsApp conversation.",
        oneDay: "24 hours",
        sevenDays: "7 days",
        thirtyDays: "30 days",
        cancel: "Cancel",
        confirm: "Pin",
        synced: "Message pinned and synced with WhatsApp.",
        localOnly: "Message pinned only in Whaticket; WhatsApp could not sync it.",
        unpinnedSynced: "Message unpinned in Whaticket and WhatsApp.",
        unpinnedLocalOnly: "Message unpinned in Whaticket; WhatsApp could not confirm the change.",
      },
      pinnedMessages: {
        title: "Pinned messages",
        pinned: "Pinned message",
        until: "until",
        image: "Image",
        audio: "Audio",
        video: "Video",
        location: "Location",
        contact: "Contact",
        message: "Message",
        you: "You",
        synced: "Synced with WhatsApp",
        localOnly: "Whaticket only",
      },
      forwardMessageModal: {
        title: "Forward message",
        fieldLabel: "Search destination ticket",
        noOptions: "No available tickets found",
        ticketHint: "Search by customer, number, department, or ticket.",
        queue: "Department",
        channel: "Channel",
        assignedTo: "Assigned",
        unassigned: "Unassigned",
        success: "Message forwarded successfully.",
        buttons: {
          cancel: "Cancel",
          ok: "Forward",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_REACT_WAPP_MSG: "Couldn't react to the WhatsApp message.",
        ERR_INVALID_REACTION: "The selected reaction is not valid.",
        ERR_PIN_WAPP_MSG: "Couldn't pin or unpin the WhatsApp message.",
        ERR_PIN_NOT_SUPPORTED: "The selected connection does not support pinned messages.",
        ERR_INVALID_PIN_DURATION: "The selected pin duration is not valid.",
        ERR_INVALID_PIN_REQUEST: "The pin request is not valid.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_MESSAGE_FOUND: "No message found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_INVALID_FORWARD_TARGET:
          "Select an open or pending ticket before forwarding this message.",
        ERR_FORWARD_MEDIA_NOT_FOUND:
          "The original media file could not be found for forwarding.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one department.",
        ERR_WAPP_INVALID_PROVIDER:
          "The chosen connection method is not valid.",
      },
    },
  },
};

export { messages };
